
import { Component, Inject } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { TranslatePipe } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-import-checklist-dialog',
  templateUrl: './import-checklist-dialog.component.html',
  styleUrls: ['./import-checklist-dialog.component.scss'],
  host: {
    class: 'ui-dialog'
  },
  providers: [TranslatePipe]
})
export class ImportCheckListDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ImportCheckListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public checklistTypes: SelectItem[],
  ) {

  }

  selectedChecklistType = '';
  filteredCheckListTypes: SelectItem[] = [];

  onClear() {
    this.selectedChecklistType = '';
  }

  onSelect($event: SelectItem) {
    this.selectedChecklistType = $event.value;
  }

  onComplete({ query = '' }) {

    this.filteredCheckListTypes = this.checklistTypes.filter(type =>
      type.label
        .toLocaleLowerCase()
        .includes(
          query
            .toLocaleLowerCase()
            .trim()
        )
    );
  }


}
